import { useTranslation } from 'react-i18next';
import { TrashIcon } from '@utils/icons';
import { VoicePlayer } from '../../../VoicePlayer/VoicePlayer';
import styles from './VoicePreviewBar.module.css';

interface IVoicePreviewBarProps {
  url: string;
  durationMs: number;
  onRemove: () => void;
}

// Full-width composer row for a pending voice note. A voice message is sent on
// its own (no text), so it takes over the editor slot rather than sitting as a
// cramped chip above it.
export function VoicePreviewBar({ url, durationMs, onRemove }: IVoicePreviewBarProps) {
  const { t } = useTranslation();
  return (
    <div className={styles.bar}>
      <VoicePlayer url={url} durationMs={durationMs} className={styles.player} />
      <button
        type="button"
        className={styles.removeBtn}
        onClick={onRemove}
        aria-label={t('comms.composer.removeAttachment')}
      >
        <TrashIcon size={14} />
      </button>
    </div>
  );
}
